// extracted by mini-css-extract-plugin
module.exports = {"Container":"index-module--Container--2YCCe"};